import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  * { margin: 0; padding: 0; }

  html { scroll-behavior: smooth; }
  html, body, #root { height: 100%; }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamilies.sans};
    font-size: ${({ theme }) => theme.typography.fontSizes.body};
    line-height: ${({ theme }) => theme.typography.lineHeights.body};
    color: ${({ theme }) => theme.ink[1]};
    background: ${({ theme }) => theme.surface.bg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-feature-settings: "ss01", "cv11";
    transition:
      background ${({ theme }) => theme.motion.duration.base} ${({ theme }) => theme.motion.easing.out},
      color ${({ theme }) => theme.motion.duration.base} ${({ theme }) => theme.motion.easing.out};
  }

  a { color: inherit; text-decoration: none; }
  button, input, select, textarea { font: inherit; color: inherit; }
  button { cursor: pointer; background: none; border: none; }

  ::selection {
    background: ${({ theme }) => theme.tone.halo.soft};
    color: ${({ theme }) => theme.tone.halo.deep};
  }
`;
